<template>
  <div class="login_box" v-if="login_show">
    <div class="login_ct">
      <div class="login_mark"></div>
      <div class="login_option">
        <!-- 头部渐变 -->
        <div class="linear">
          <div class="linear_lt" @click="isloginType == 'phone' ? isloginType = 'pass' : isloginType = 'phone'">
            <img v-if="phoneSteep === 1"
              :src="isloginType == 'phone' ? require('@/assets/image/phone_icon.png') : require('@/assets/image/pass_icon.png')"
              alt="">
          </div>
          <div v-if="phoneSteep === 2" class="code_title">请输入验证码</div>
          <div class="linear_rt">
            <img @click="handelClosePop" src="@/assets/image/reserve_cancel_ic.png" alt="">
          </div>
        </div>
        <div v-if="phoneSteep === 2" class="code_tip">
          <p v-if="!codeError">短信验证码已发送至 +86 {{ myPhone }}</p>
          <pre v-else>{{ codeError }}</pre>
        </div>
        <!-- logo -->
        <div v-if="phoneSteep === 1" class="logo">
          <img src="@/assets/image/50_logo.png" alt="">
        </div>
        <!-- 手机登录 -->
        <div v-if="isloginType == 'phone' && phoneSteep === 1" class="phone_option_ct">
          <div class="login_tips">
            <h2>手机号登录/注册 </h2>
            <div>未注册手机号完成登录后自动注册</div>
          </div>
          <div class="input_box">
            <div class="input_tip">+86</div>
            <input v-model="phone" class="input_value" type="text" placeholder="请输入手机号">
          </div>
          <p v-if="phoneNumError" class="text_tip">{{ phoneNumError }}</p>
          <div class="submit_btn" @click="phoneLogin" :style="{ opacity: getCodeDisable ? '0.5' : '1' }">登录</div>
        </div>
        <!-- 账号密码登录 -->
        <div v-if="isloginType == 'pass' && phoneSteep === 1" class="pass_option_ct">
          <div class="login_tips">
            <h2>账号登录 </h2>
          </div>
          <div class="input_box">
            <input class="input_value" v-model="name" @input="TelInput" type="text" placeholder="请输入手机号/用户名">
          </div>
          <div class="input_box">
            <input v-model="password" @input="PasswordInput" class="input_value" type="text" placeholder="请输入密码">
            <span @click="isloginType = 'forgotPhone'" class="input_forgot">忘记密码</span>
          </div>
          <p v-if="pswNumError.length > 0" class="text_tip">{{ pswNumError }}</p>
          <div class="submit_btn" @click="pswLogin"
            :style="{ opacity: (is_password_err || is_name_err) ? '0.5' : '1' }">
            登录</div>
        </div>
        <!-- 忘记密码---手机号页面 -->
        <div v-if="isloginType == 'forgotPhone' && phoneSteep === 1" class="phone_option_ct">
          <div class="login_tips">
            <h2>忘记密码 </h2>
            <!-- <div>未注册手机号完成登录后自动注册</div> -->
          </div>
          <div class="input_box">
            <div class="input_tip">+86</div>
            <input v-model="forgotPhone" class="input_value" type="text" placeholder="请输入手机号">
          </div>
          <p v-if="forgotPhoneNumError" class="text_tip">{{ forgotPhoneNumError }}</p>
          <div class="submit_btn" @click="forgotPhoneLogin" :style="{ opacity: getForgotCodeDisable ? '0.5' : '1' }">
            确认</div>
        </div>
        <!-- 忘记密码---填写密码页面 -->
        <div v-if="isloginType == 'forgotPhone' && phoneSteep === 3" class="pass_option_ct">
          <div class="login_tips">
            <h2>找回密码 </h2>
          </div>
          <div class="input_box">
            <input class="input_value" v-model="new_password" @input="PasswordInput" type="text"
              placeholder="新密码(6-16位数字或字母，区分大小写)">
          </div>
          <div class="input_box">
            <input v-model="s_new_password" @input="PasswordInput" class="input_value" type="text"
              placeholder="再次确认密码(与上面保持一致)">
          </div>
          <p v-if="findNumError.length > 0" class="text_tip">{{ findNumError }}</p>
          <div class="submit_btn" @click="findPass"
            :style="{ opacity: (!new_password || !s_new_password) ? '0.5' : '1' }">
            确认</div>
        </div>
        <!-- 协议及其它登录方式 -->
        <div v-if="phoneSteep === 1" class="all_login_type">
          <!-- <div class="all_login_type_tip">
            ——&nbsp;&nbsp;&nbsp;&nbsp;其它登录方式&nbsp;&nbsp;&nbsp;&nbsp;——
          </div>
          <div class="loing_type_ct">
            <img src="@/assets/image/wechat.png" alt="">
            <img src="@/assets/image/douyin.png" alt="">
          </div> -->
          <div class="login_type_serve" :class="agreeAm ? 'shake' : ''">
            <i @click="agree = !agree" :class="agree ? 'select' : ''"></i>
            已阅读并同意<span @click.stop="toPush('agreementDetail')">《50游戏用户服务协议》</span>和<span
              @click.stop="toPush('PrivacyDetail')">《隐私政策》</span>
          </div>
        </div>
        <!-- 手机号登录验证码 忘记密码or手机号码登录-->
        <div v-if="phoneSteep === 2" class="inpot_code">
          <div class="inpot_code_box">
            <input v-for="(value, index) in code" v-model="code[index]"
              @input="handleInputChange(index, $event.target.value)" @focus="focusIndex = index"
              @blur="focusIndex = null" type="text" :id="'input-' + index" :class="focusIndex === index ? 'select' : ''"
              :key="'input_value_' + index" maxlength="1">
          </div>
          <div @click="similarly" class="angin_btn" :style="{ opacity: is_get_code_disable ? '0.5' : '1' }">重新发送 {{
            reget_code_time ? reget_code_time : '' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regMethods from '@/mixs/regMethods'
import { postData } from '@/api/api.js'
import { mapMutations, mapState } from 'vuex'
import { debounce } from "@/util/util";
import Bus from '@/util/Bus'

export default {
  name: 'Phone',
  props: {
    login_show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mixins: [regMethods],
  data() {
    return {
      isloginType: 'phone',//是否显示密码登录or手机号登录
      phoneSteep: 1,// 手机号登录第一步 1为手机号&密码----2为输入验证码----3重置密码
      //验证码登录数据
      code: ['', '', '', ''], // 验证码四位
      focusIndex: null,
      phone: '',
      phoneNumError: '',// 手机号码错误提示
      is_get_code_disable: true,// 重新发送验证码禁用样式
      getCodeDisable: true,// 登录按钮禁用样式
      reget_code_time: 0, // 重新获取验证码倒计时
      captcha_length: 4, // 验证码长度,在 4 - 6 之间
      codeError: '',
      agree: false,//协议
      agreeAm: false,//协议动画
      // ---密码登录数据
      pswNumError: '',
      name: '',
      password: '',
      is_password_err: true, // 密码是否输入
      is_name_err: true,//账号是否输入
      // ---忘记密码数据
      forgotPhoneNumError: '',
      forgotPhone: '',
      getForgotCodeDisable: true,
      // 找回密码---数据
      findNumError: '',
      new_password: '',
      s_new_password: '',
      captcha_token: '',
    }
  },
  created() {
    this.debouncedGetTokenByPhone = debounce(this.getTokenByPhone, 500);
    this.debouncedLoginByName = debounce(this.loginByName, 2000, true);
    this.debouncedGetPswTokenByPhone = debounce(this.getPswTokenByPhone, 2000, true);

  },
  methods: {
    ...mapMutations(['handelUid', 'clearLoggedInUser', 'handelSdkGid']),
    // 重置参数
    reset() {
      this.isloginType = 'phone'
      // 手机号登录第一步 1为手机号&密码----2为输入验证码
      this.phoneSteep = 1
      // 协议
      this.agree = false
      // 验证码四位
      this.code = ['', '', '', '']
      this.focusIndex = null
      this.phone = ''
      this.phoneNumError = ''// 手机号码错误提示
      this.is_get_code_disable = true// 重新发送验证码禁用样式
      this.getCodeDisable = true// 登录按钮禁用样式
      this.reget_code_time = 0 // 重新获取验证码倒计时
      this.agree = false//协议
      this.agreeAm = false//协议动画
      this.captcha_length = 4 // 验证码长度,在 4 - 6 之间
      this.codeError = ''
      this.pswNumError = ''
      this.name = ''
      this.password = ''
      this.is_password_err = true// 密码是否输入
      this.is_name_err = true//账号是否输入
      // ---忘记密码数据
      this.forgotPhoneNumError = ''
      this.forgotPhone = ''
      this.getForgotCodeDisable = true
      // 找回密码---数据
      this.findNumError = ''
      this.new_password = ''
      this.s_new_password = ''
      this.captcha_token = ''
    },
    // 关登录弹窗
    handelClosePop() {
      Bus.$emit("loginShow", false);
    },
    // 验证码输入
    handleInputChange(index, value) {
      this.$set(this.code, index, value)
      // 只有 index < code.length - 1 才焦点到下一个输入框
      if (value && index < this.code.length - 1) {
        setTimeout(() => {
          const nextInput = document.getElementById(`input-${index + 1}`)
          if (nextInput) nextInput.focus()
        }, 10)
      }
    },
    // 手机号登录发送验证码按钮
    phoneLogin() {
      // 手机号码正确且同意协议
      if (this.getCodeDisable) return
      // 协议
      if (!this.agree) {
        this.agreeAm = true
        setTimeout(() => {
          this.agreeAm = false
        }, 1000);
        return
      }
      this.phoneSteep = 2 //验证码步骤
      this.sendCodeTime()
      this.sendCaptcha()
    },
    // 发送验证码倒计时
    sendCodeTime() {
      this.reget_code_time = 60
      this.is_get_code_disable = true
      const lamp = setInterval(() => {
        if (this.reget_code_time > 1) {
          this.reget_code_time--
        } else {
          this.is_get_code_disable = false
          this.reget_code_time = 0
          clearInterval(lamp)
        }
      }, 1000)
    },
    // 重新发送验证码倒计时
    similarly() {
      if (this.is_get_code_disable) return
      if (this.isloginType === 'phone') {
        this.sendCodeTime()
        this.sendCaptcha()
      } else if (this.isloginType === 'fotgotPhone') {
        this.sendCodeTime()
        this.sendPwdCaptcha()
      }
    },
    // 手机号登录发送获取 Token 的验证码
    async sendCaptcha(cb) {
      const endpoint = '/user/get-token-by-phone/send-captcha'
      const params = {
        phone: this.phone,
        captcha_length: this.captcha_length,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        cb && cb()
      } else {
      }
    },
    // 通过手机号获取验证码---获取 token
    async getTokenByPhone() {
      // this.$message.error({
      //   message: '提交成功！',
      //   center: true, // 设置消息居中
      //   duration: 2000 // 消息持续时间
      // }); // 显示成功消息
      const endpoint = '/user/get-token-by-phone'
      const params = {
        gid: 0, // 游戏id
        lid: this.requestParams.lid, // 包链接id
        equipment_id: this.requestParams.equmentid, // 客户端设备号（imei、idfa）
        equipment_idfv: this.requestParams.equmentidfv, // 客户端重装标识
        rest: { test: 0 }, // 其他数据，包含客户端信息的 json 字符串
        phone: this.phone, // 手机号码
        captcha: this.code.join(''), // 验证码
        apptype: 'gamebox',
        package_id: this.requestParams.package_id,//包id
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
        is_link: this.requestParams.is_link,
        platform: this.platform,
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.LoginCompleted(res)
      } else if (res.code == -1) {
        this.codeError = res.msg // 验证码错误提示
      } else {
        this.codeError = res.msg // 验证码错误提示
      }
    },
    // 密码登录按钮
    pswLogin() {
      if (this.is_password_err || this.is_name_err) return
      // 协议
      if (!this.agree) {
        this.agreeAm = true
        setTimeout(() => {
          this.agreeAm = false
        }, 1000);
        return
      }
      this.debouncedLoginByName()
    },
    // 通过用户名和密码获取token
    async loginByName() {
      const endpoint = '/user/login-by-name'
      const params = {
        gid: this.requestParams.gid, // 游戏id
        lid: this.requestParams.lid, // 包链接id
        equipment_id: this.requestParams.equmentid, // 客户端设备号（imei、idfa）
        equipment_idfv: this.requestParams.equmentidfv, // 客户端重装标识
        platform: this.platform, // 平台(0-安卓,1-IOS,2-H5)
        rest: { test: 0 }, // 其他数据，包含客户端信息的 json 字符串
        name: this.name, // 用户名
        password: this.password, // 密码
        apptype: 'gamebox',
        package_id: this.requestParams.package_id,//包id
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
        cleanboxtoken: 0,//1为手动清除信任设备
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.LoginCompleted(res)
      } else if ([-2, -1005].includes(res.code)) {
        // 密码错误
        this.pswNumError = res.msg
      } else if (res.code === -1004) {
        // 用户名错误
        this.pswNumError = res.msg
      } else {
        this.pswNumError = res.msg
      }
    },
    TelInput() {
      this.name = this.name.replace(/[^a-zA-Z0-9]/g, '');
    },
    PasswordInput() {
      this.password = this.password.replace(/[^a-zA-Z0-9]/g, '');
      this.s_new_password = this.s_new_password.replace(/[^a-zA-Z0-9]/g, '');
      this.new_password = this.new_password.replace(/[^a-zA-Z0-9]/g, '');
    },
    // 以下为手机登录&&密码登录---------------通用存储信息
    LoginCompleted(res, obj = {}) {
      // 重置参数&&关闭弹窗
      // 关登录弹窗
      this.handelClosePop()
      this.reset()
      this.handelSdkGid(0)
      // access_token更新
      window.localStorage.setItem("access_token", res.data.access_token, res.data.expires_in);
      window.localStorage.setItem("refresh_token", res.data.refresh_token, res.data.refresh_token_expires_in);
      if (res.data.is_register === 1) {
        //注册成功通知----todo
        Bus.$emit('is_register')
      }
      this.handelUid(res.data.uid)
      this.getUserInfo(res.data.access_token)
      this.getLoginMes()
      this.clearLoggedInUser()
      //mq----todo
      Bus.$emit("LinkMqtt");
      // 第三方登陆-网页
      // if (obj.lonintype == 1) return window.location.replace(window.location.origin + window.location.pathname)
    },
    // 登录完成请求参数
    async getLoginMes() {
      const endpoint = '/box/login'

      const params = {
        gid: this.requestParams.gid, // 游戏id
        uid: this.uid,
        sub_uid: '',
        lid: this.requestParams.lid, // 包链接id
        equipment_id: this.requestParams.equmentid, // 客户端设备号（imei、idfa）
        equipment_idfv: this.requestParams.equmentidfv, // 客户端重装标识
        platform: this.platform, // 平台(0-安卓,1-IOS,2-H5)
        access_token: window.localStorage.getItem('access_token'),
        rest: { test: 0 }, // 其他数据，包含客户端信息的 json 字符串
        apptype: 'gamebox',
        subchannelnum: 0,//广告商分包id
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        window.localStorage.setItem('loginMes', true)
        // 刷新数据缓存
        Bus.$emit("uploadData");
        window.location.reload(true);
        // 跳转路由 刷新视图
        // this.$router.replace({
        //   path: this.$route.path,
        //   query: { ...this.$route.query, _t: Date.now() }  // 添加一个随机/时间戳参数
        // })
        // this.$forceUpdate()
      } else if (res.code == '-1001') {
      }
    },
    // 用户信息获取
    async getUserInfo(token) {
      const endpoint = '/box-user/user-info'
      const params = {
        gid: this.requestParams.gid,
        lid: this.requestParams.lid,
        equipment_id: this.requestParams.equmentid,
        equipment_idfv: this.requestParams.equmentidfv,
        access_token: token,
        uid: this.uid,
        sub_uid: 0,
        rest: {},
        apptype: 'gamebox',
        subchannelnum: this.requestParams.subchannelnum, // 广告商分包id
        platform: this.platform,
      }
      const res = await postData(endpoint, params)
      console.log(res, 999)
      if (res?.code === 0) {
        window.localStorage.setItem('userInfo', JSON.stringify(res.data))
      }
    },
    // ------
    // 忘记密码
    // 忘记密码获取验证码按钮
    async forgotPhoneLogin() {
      // 手机号码正确且同意协议
      if (this.getForgotCodeDisable) return
      // 协议
      if (!this.agree) {
        this.agreeAm = true
        setTimeout(() => {
          this.agreeAm = false
        }, 1000);
        return
      }
      this.phoneSteep = 2 //验证码步骤
      this.sendCodeTime()
      this.sendPwdCaptcha()
    },
    // 找回密码---确认按钮
    async findPass() {
      if (!this.new_password || !this.s_new_password) return
      if (this.new_password != this.s_new_password) return this.findNumError = '两次密码不一致'
      if (
        !this.pswReg(this.new_password) ||
        !this.pswReg(this.s_new_password)
      ) {
        return this.findNumError = '密码格式不对'
      }
      const endpoint = '/user/chg-pwd/by-captcha-token'
      const params = {
        phone: this.forgotPhone,
        captcha: this.code.join(''), // 验证码
        captcha_token: this.captcha_token,
        password: this.new_password, // 新密码
        password_confirmation: this.s_new_password,//确认密码
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.$message.success({
          message: '密码设置成功',
          center: true, // 设置消息居中
          duration: 2000 // 消息持续时间
        }); // 显示成功消息
        // 先恢复默认数据
        this.reset()
        // 在跳转回密码登录界面
        this.phoneSteep = 1
        this.isloginType = 'pass'
      } else {
        this.$message.error({
          message: res.msg,
          center: true, // 设置消息居中
          duration: 2000 // 消息持续时间
        }); // 显示成功消息
      }
    },
    // 手机号找回密码发送获取 Token 的验证码
    async sendPwdCaptcha(cb) {
      const endpoint = '/user/chg-pwd/send-captcha'
      const params = {
        phone: this.forgotPhone,
        captcha_length: this.captcha_length,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {

        cb && cb()
      } else {
      }
    },
    // 手机号找回密码发送获取-通过验证码获取 token
    async getPswTokenByPhone() {
      const endpoint = '/user/chg-pwd/check-captcha'
      const params = {
        phone: this.forgotPhone, // 手机号码
        captcha: this.code.join(''), // 验证码
        apptype: 'gamebox',
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.captcha_token = res.data.captcha_token
        this.phoneSteep = 3
      } else if (res.code == -1) {
        this.codeError = res.msg // 验证码错误提示
      } else {
        this.codeError = res.msg // 验证码错误提示
      }
    },
    // 跳转
    toPush(path) {
      if (path == 'agreementDetail') {
        window.open('http://yapisdk.50pk.com/storage/agreement/v1/privacy.html', '_blank');
      } else {
        window.open('http://yapisdk.50pk.com/storage/agreement/v1/user.html', '_blank');
      }
    },
  },
  computed: {
    ...mapState(['uid', 'requestParams', 'platform', 'platformH5']),
    myPhone() {
      return localStorage.getItem('myPhone') || ''; // 从 localStorage 获取手机号，设置默认值为空字符串
    }
  },
  watch: {
    phone(val) {
      if (val.length >= 11) {
        if (!this.phoneReg(val)) {
          this.phoneNumError = '手机号码不正确' // 手机号码错误提示
          this.getCodeDisable = true
        } else {
          window.localStorage.setItem('myPhone', val)
          this.phoneNumError = ''
          this.getCodeDisable = false
        }
      } else {
        this.phoneNumError = ''
        this.getCodeDisable = true
      }
    },
    code(val) {
      // 处理验证码数组
      const codeInput = val.join(''); // 将数组转为字符串
      if (codeInput.length === 4) {
        // 当验证码长度为4时，触发获取 token 的方法
        console.log(this.isloginType, "this.isloginType")
        if (this.isloginType === 'phone') {
          this.debouncedGetTokenByPhone();
        } else if (this.isloginType === 'forgotPhone') {
          this.debouncedGetPswTokenByPhone()
        }
      }
      // 如果验证码为空，清空错误提示
      if (codeInput.length === 0) {
        this.codeError = ''; // 清空验证码错误提示
      } else if (codeInput.length < 4) {
        // 如果输入的验证码少于4位，给出相应提示（可选）
        this.codeError = '请输入完整的验证码';
      }
    },
    forgotPhone(val) {
      if (val.length >= 11) {
        if (!this.phoneReg(val)) {
          this.forgotPhoneNumError = '手机号码不正确' // 手机号码错误提示
          this.getForgotCodeDisable = true
        } else {
          window.localStorage.setItem('myPhone', val)
          this.forgotPhoneNumError = ''
          this.getForgotCodeDisable = false
        }
      } else {
        this.forgotPhoneNumError = ''
        this.getForgotCodeDisable = true
      }
    },
    name(val) {
      if (val.length > 0) {
        this.is_name_err = false;
      } else if (val.length == 0) {
        this.is_name_err = true;
      }
      if (this.pswNumError) {
        this.pswNumError = "";
      }
    },
    password(val) {
      if (val.length > 0) {
        this.is_password_err = false;
      } else if (val.length == 0) {
        this.is_password_err = true;
      }
      if (this.pswNumError) {
        this.pswNumError = "";
      }
    },
    new_password(val) {
      if (this.findNumError) {
        this.findNumError = "";
      }
    },
    s_new_password(val) {
      if (this.findNumError) {
        this.findNumError = "";
      }
    },
  }
}
</script>

<style scoped lang="less">
.login_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
}

.login_ct {
  position: relative;
  width: 100%;
  height: 100%;

  .login_mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .login_option {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 550px;
    // height: 684px;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 0 0 40px 0;
    z-index: 2;

    .linear {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 50px;
      padding: 25px 26px 10px 16px;
      box-sizing: border-box;
      border-radius: 20px 20px 0 0;
      background: linear-gradient(to bottom, #FFE8E9, #FFFFFF);

      .linear_lt {
        cursor: pointer;
      }

      .code_title {
        font-size: 20px;
        font-weight: 700;
      }

      .linear_rt {
        width: 16px;
        height: 16px;
        // align-self: flex-start;
      }
    }

    .logo {
      padding: 0 85px;
      box-sizing: border-box;
    }

    .code_tip {
      margin: 50px 0 30px 0;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.6);

      pre {
        color: #FF3838;
      }
    }

    .phone_option_ct,
    .pass_option_ct {
      padding: 0 85px;
      box-sizing: border-box;

      .login_tips {
        margin: 40px 0 50px 0;
        text-align: left;

        >div {
          margin-top: 10px;
          font-size: 13px;
          color: #A5A5A5;
        }

        >h2 {
          font-size: 18px;
          font-weight: 700;
        }
      }

      .input_box {
        display: flex;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid #E6E6E6;

        .input_tip {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 26px;
          font-size: 16px;
          border-radius: 13px;
          color: #ffffff;
          background-color: #C7C7C7;
        }

        .input_value {
          flex: 1;
          margin-left: 10px;

          &::placeholder {
            font-size: 16px;
            color: #A5A5A5;
          }
        }

        .input_forgot {
          font-size: 16px;
          color: #FF8637;
          cursor: pointer;
        }
      }

      .text_tip {
        margin-top: 5px;
        font-size: 12px;
        text-align: left;
        color: #FF3838;
      }

      .submit_btn {
        width: 100%;
        height: 42px;
        margin-top: 110px;
        line-height: 42px;
        border-radius: 21px;
        font-size: 16px;
        color: #ffffff;
        background-color: #FF3838;
        cursor: pointer;
      }
    }

    .pass_option_ct {
      .login_tips {
        margin: 40px 0 40px 0;
      }

      .input_box {
        margin-top: 10px !important;
      }

      .submit_btn {
        margin-top: 50px;
        cursor: pointer;
      }
    }

    .all_login_type {
      margin-top: 60px;

      .all_login_type_tip {
        font-size: 12px;
        color: #A5A5A5;
      }

      .loing_type_ct {
        display: flex;
        align-items: center;
        justify-content: center;

        >img {
          margin: 20px 30px;
        }
      }

      .login_type_serve {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #D9D9D9;

        i {
          display: inline-block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          border: 1px solid #D9D9D9;
          margin-right: 10px;
        }

        .select {
          background-image: url('@/assets/image/bind_suc.png');
          background-size: cover;
          // border: none;
        }

        span {
          cursor: pointer;
          color: #FF8637;
        }
      }
    }

    .inpot_code {
      position: relative;
      width: 273px;
      margin: 0 auto;

      .inpot_code_box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 10px;
        box-sizing: border-box;

        >input {
          width: 60px;
          height: 60px;
          text-align: center;
          border-radius: 12px;
          background-color: #EDEDED;
          line-height: 60px;
          font-weight: bold;
          font-size: 40px;
          margin-left: 10px;
        }

        .select {
          background-color: #FF8637;
        }
      }

      .angin_btn {
        width: 100%;
        height: 42px;
        margin-top: 30px;
        line-height: 42px;
        border-radius: 21px;
        font-size: 16px;
        color: #ffffff;
        background-color: #FF3838;
        cursor: pointer;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

.shake {
  animation: shake 0.5s ease-in-out;
}
</style>
